var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('admin-person-info'):_c('customer-person-info')}
var staticRenderFns = []

export { render, staticRenderFns }